<div bringoz-id-generator="serviceInfoBtn"
     class="layout-row layout-align-start-center full-height">
  <bringoz-icon iconName="info-outline"
                fill="#A3A3A3"
                ngbTooltip="{{'Delivery Info' | translate}}"
                (click)="open($event)">

  </bringoz-icon>
</div>
